import { useContext } from "react";
import { LangContext } from "../../context/LangContext";

import "./style.css"

function Paging({ data, paging, setPaging }) {
    const { translations } = useContext(LangContext);

    return (
        <div className="paging">
            <button onClick={() => setPaging(paging !== 0 ? paging - 1 : paging)}>
                {'<- '}
                <span>{translations.return}</span>
                {' --'}
            </button>

            <span className='counter'>( {paging + 1} / {data.length} )</span>

            <button onClick={() => setPaging(paging !== data.length - 1 ? paging + 1 : paging)}>
                {'-- '}
                <span>{translations.next}</span>
                {' ->'}
            </button>
        </div>
    )
}

export default Paging;